import {
  COMMUNITY_CONFIGS_LOADING,
  COMMUNITY_MANAGEMENT_MEMBERSHIPS_LOADING,
  COMMUNITY_OWNERSHIPS_LOADING, 
  COMMUNITY_STATISTICS_LOADING,
  LOAD_COMMUNITY_CONFIGS,
  LOAD_COMMUNITY_CONFIGS_ERROR,
  LOAD_COMMUNITY_CONFIGS_SUCCESS,
  LOAD_COMMUNITY_MEMBERSHIPS,
  LOAD_COMMUNITY_MEMBERSHIPS_ERROR,
  LOAD_COMMUNITY_MEMBERSHIPS_SUCCESS,
  LOAD_COMMUNITY_OWNERSHIPS,
  LOAD_COMMUNITY_OWNERSHIPS_ERROR,
  LOAD_COMMUNITY_OWNERSHIPS_SUCCESS,
  LOAD_COMMUNITY_STATISTICS, 
  LOAD_COMMUNITY_STATISTICS_ERROR,
  LOAD_COMMUNITY_STATISTICS_SUCCESS,
  LOAD_MORE_COMMUNITY_MEMBERSHIPS,
  LOAD_MORE_COMMUNITY_MEMBERSHIPS_SUCCESS,
  MORE_COMMUNITY_MANAGEMENT_MEMBERSHIPS_LOADING
} from "./actionTypes";
import ICommunityOwnership from "../../communities/types/ICommunityOwnership";
import { ILoadCommunityMgmtMembershipsFilter } from "../../communities/types/ILoadCommunityMgmtMembershipsFilter";
import { IPagedCommunityMgmtMemberships } from "../../communities/types/IPagedCommunityMgmtMemberships";
import ICommunityConfig from "../../communities/types/ICommunityConfig";
import { ICommunityStatistic } from "../../communities/types/ICommunityStatistic";

export const loadCommunityOwnerships = () => {
  return { type: LOAD_COMMUNITY_OWNERSHIPS };
};

export const loadCommunityOwnershipsSuccess = (communityOwnerships: ICommunityOwnership[]) => {
  return {
    type: LOAD_COMMUNITY_OWNERSHIPS_SUCCESS,
    communityOwnerships
  };
}

export const loadCommunityOwnershipsError = (errorMessage: string) => {
  return {
    type: LOAD_COMMUNITY_OWNERSHIPS_ERROR,
    errorMessage
  };
}

export const loadCommunityMemberships = (filter: ILoadCommunityMgmtMembershipsFilter) => {
  return {
    type: LOAD_COMMUNITY_MEMBERSHIPS,
    filter,
  };
};

export const loadCommunityMembershipsSuccess = (pagedCommunityMgmtMemberships: IPagedCommunityMgmtMemberships) => {
  return {
    type: LOAD_COMMUNITY_MEMBERSHIPS_SUCCESS,
    communityMemberships: pagedCommunityMgmtMemberships
  };
}

export const loadMoreCommunityMemberships = (filter: ILoadCommunityMgmtMembershipsFilter) => {
  return {
    type: LOAD_MORE_COMMUNITY_MEMBERSHIPS,
    filter,
  };
}

export const loadMoreCommunityMembershipsSuccess = (pagedCommunityMgmtMemberships: IPagedCommunityMgmtMemberships) => {
  return {
    type: LOAD_MORE_COMMUNITY_MEMBERSHIPS_SUCCESS,
    communityMemberships: pagedCommunityMgmtMemberships
  };
}

export const loadCommunityMembershipsError = (errorMessage: string) => {
  return {
    type: LOAD_COMMUNITY_MEMBERSHIPS_ERROR,
    errorMessage
  };
}

export const loadCommunityConfigs = (communityCodes: string[]) => {
  return {
    type: LOAD_COMMUNITY_CONFIGS,
    communityCodes
  }
}

export const loadCommunityConfigsSuccess = (communityConfigs: ICommunityConfig[]) => {
  return {
    type: LOAD_COMMUNITY_CONFIGS_SUCCESS,
    communityConfigs
  }
}

export const loadCommunityConfigsError = (errorMessage: string) => {
  return {
    type: LOAD_COMMUNITY_CONFIGS_ERROR,
    errorMessage
  }
}

export const loadCommunityStatistics = () => {
  return {
    type: LOAD_COMMUNITY_STATISTICS
  }
}

export const loadCommunityStatisticsSuccess = (communityStatistics: ICommunityStatistic[]) => {
  return {
    type: LOAD_COMMUNITY_STATISTICS_SUCCESS,
    communityStatistics
  }
}

export const loadCommunityStatisticsError = (errorMessage: string) => {
  return {
    type: LOAD_COMMUNITY_STATISTICS_ERROR,
    errorMessage
  }
}

export const communityOwnershipsLoading = (loading: boolean) => {
  return {
    type: COMMUNITY_OWNERSHIPS_LOADING,
    loading
  }
}

export const communityManagementMembershipsLoading = (loading: boolean) => {
  return {
    type: COMMUNITY_MANAGEMENT_MEMBERSHIPS_LOADING,
    loading
  }
}

export const loadMoreCommunityManagementMembershipsLoading = (loading: boolean) => {
  return {
    type: MORE_COMMUNITY_MANAGEMENT_MEMBERSHIPS_LOADING,
    loading
  }
}

export const communityConfigsLoading = (loading: boolean) => {
  return {
    type: COMMUNITY_CONFIGS_LOADING,
    loading
  }
}

export const communityStatisticsLoading = (loading: boolean) => {
  return {
    type: COMMUNITY_STATISTICS_LOADING,
    loading
  }
}





// WEBPACK FOOTER //
// ./src/modules/core/actions/communitiesActions.tsx